
<div mat-dialog-title class="name">
  Seleccione colecciones a importar
</div>

<div mat-dialog-content class="content">
  <mat-form-field>
    <mat-label>Items</mat-label>
    <mat-select class="grid-full" [(ngModel)]="selectedItems" multiple>
      <mat-option selectAll [value]="0">Seleccionar todos</mat-option>
      @for (item of items; track item.id) {
        <mat-option [value]="item.id">
          {{item.name}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <span class="name" *ngIf="items.length === 0">No hay colecciones para importar</span>
</div>  
<div mat-dialog-actions class="footer">
  <button mat-button (click)="closeDialog()">Cancelar</button>
  <button mat-button cdkFocusInitial (click)="import()">Importar</button>
</div>